export const APP_NAMES = {
  COCHES: 'coches',
  MOTOS: 'motos'
}

export const COOKIE_DOMAIN = '.coches.net'
export const SEGMENT_ANONYMOUS_COOKIE_KEY = 'ajs_anonymous_id'
export const SEGMENT_USER_ID_COOKIE_KEY = 'ajs_user_id'

export const appName = process.env.TENANT
export const isCoches = appName === APP_NAMES.COCHES
export const isDevelopment = process.env.NODE_ENV !== 'production'

export const PATH_NAMES = {
  COMPARADOR: 'comparador',
  NET: 'assistant',
  DEALERS_LISTS: 'concesionarios',
  INSTANT_OFFER: {
    COCHES: 'vende-a-concesionario',
    MOTOS: 'vende-a-profesional'
  },
  RECOMMENDATIONS: 'recommendations',
  SEARCH: 'search',
  SELL_MY_VEHICLE: {
    COCHES: 'vender-mi-coche',
    MOTOS: 'vender-mi-moto'
  },
  STOCK: 'concesionario',
  SUBSCRIPTION: 'renting',
  TECHNICAL_DETAILS: 'fichas_tecnicas',
  VEHICLE_SUGGESTER: 'ayudame-a-elegir',
  VEHICLE_CONFIGURATOR_V3: 'configurador',
  USER: 'user'
}

export const ROUTES = {
  ADS_LIST_SEARCH: `/${PATH_NAMES.SEARCH}/`,
  ADS_LIST_SUBSCRIPTION: `/${PATH_NAMES.SUBSCRIPTION}*`,
  CHECKOUT: {
    INDEX: '/checkout',
    SUCCESS: 'success',
    ERROR: 'error',
    PENDING: 'pending',
    REFUND_ERROR: 'refund-error',
    ACTIVATION_ERROR: 'activation-error',
    REQUEST_ERROR: 'request-error',
    UNKNOWN_ERROR: 'unknown-error'
  },
  COMPARATOR: `/${PATH_NAMES.COMPARADOR}/`,
  NET: `/${PATH_NAMES.NET}`,
  COOKIE_POLICY: '/cookies-otros-partners',
  DEALERS_LIST: {
    INDEX: `/${PATH_NAMES.DEALERS_LISTS}/`,
    PROVINCE: `/${PATH_NAMES.DEALERS_LISTS}/*`
  },
  DEFAULT: '/*',
  DETAIL: {
    INDEX: '/detail/',
    AD: '/detail/:adId'
  },
  DETAIL_PREVIEW: '/preview/:adId',
  END_INTEGRATION: '/finalizar-integracion',
  FINANCING: '/financiacion',
  FORMALITIES: {
    COCHES: '/tramites-compra-venta-coches',
    MOTOS: '/tramites-compra-venta-motos'
  },
  FORMALITIES_SECURITY_GUIDELINES: {
    COCHES: '/guia-seguridad-compra-venta-coches',
    MOTOS: '/guia-seguridad-compra-venta-motos'
  },
  HOME: '/',
  INSTANT_OFFER: {
    COCHES: `/${PATH_NAMES.INSTANT_OFFER.COCHES}/(:adId)`,
    MOTOS: `/${PATH_NAMES.INSTANT_OFFER.MOTOS}/(:adId)`
  },
  INSTANT_OFFER_NEXT_APPOINTMENT: `/vende-a-concesionario-siguiente-cita`,
  INSTANT_OFFER_STANDALONE: {
    COCHES: '/vender-mi-coche-a-un-concesionario',
    MOTOS: '/vender-mi-moto-a-un-profesional'
  },
  INSURANCE: '/seguros',
  MESSAGING_ACTION_PROXY: {
    C2B_SELLER: '/c2b/seller',
    C2B_BUYER: '/c2b/buyer',
    RESERVATION_SELLER: '/reservation/seller',
    RESERVATION_BUYER: '/reservation/buyer',
    TRANSACTION_SELLER: '/transaction/seller',
    TRANSACTION_BUYER: '/transaction/buyer'
  },
  LANDING_INSTANT_OFFER: '/vender-coche-a-un-concesionario',
  // web_seller_instant_offer_landing_test
  LANDING_INSTANT_OFFER_TEST: '/vender-coche-a-un-profesional',
  LOGIN: '/login',
  LOGOUT: '/logout.aspx', // monolith route for now
  NEWS: {
    INDEX: '/noticias',
    TAG: 't/:tag',
    CATEGORY: ':category'
  },
  NEWS_PREVIEW: {
    INDEX: '/preview-news-detail',
    DETAIL: '/preview-news-detail/:articleId'
  },
  NEWS_SECTION_COMPARATIVAS: '/comparativas',
  NEWS_SECTION_TIPS: '/consejos',
  NEWS_SECTION_TRENDS: '/tendencias',
  NEWS_SECTION_VIDEOS: '/videos',
  PAYMENT_AD: '/payment-ad',
  PRODUCTS: '/products',
  AD_MANAGEMENT: {
    MY_ADS: '/mis-anuncios'
  },
  AD_PUBLISHER: {
    EDIT_MY_AD: '/editar-mi-anuncio',
    PUBLISH_MY_AD: '/publicar-mi-anuncio',
    PUBLISH_MY_AD_CATEGORY: '/publicar-mi-anuncio/categoria',
    PUBLISH_MY_AD_WITH_PLATE: '/vender-mi-coche-con-matricula'
  },
  SELL_MY_VEHICLE: {
    COCHES: {
      INDEX: `/${PATH_NAMES.SELL_MY_VEHICLE.COCHES}`,
      LOCATION: `/${PATH_NAMES.SELL_MY_VEHICLE.COCHES}(/)(:location)`
    },
    MOTOS: {
      INDEX: `/${PATH_NAMES.SELL_MY_VEHICLE.MOTOS}`,
      LOCATION: `/${PATH_NAMES.SELL_MY_VEHICLE.MOTOS}(/)(:location)`
    }
  },
  MAKES_SIZES_DISTRIBUTOR: '/s/medidas/',
  MAKE: '/s/:make/',
  RATING: '/rating/:tradeId/',
  RECOMMENDATIONS: `/recommendations/`,
  RESERVATION: {
    // deprecated, but still used in some email templates
    EMAIL: '/reservation/email',
    // new route for reservation init, used in email templates and for the reservation flow via whatsapp too
    INIT: '/reservation/init',
    PAYMENT: '/reservation/payment',
    PAYMENT_ERROR: '/reservation/payment/error',
    REFUND: '/reservation/refund',
    REFUND_ERROR: '/reservation/refund/error',
    REFUND_REASON: '/reservation/refund/reason',
    PAYMENT_SUCCESS: '/reservation/payment/success',
    PHONE_NUMBER_REQUIRED: '/reservation/phone/required'
  },
  SECURE_PAYMENT_KYC: '/kyc-pago-seguro/',
  SELLER_SECURE_PAYMENT_BENEFITS: '/beneficios-vendedor-pago-seguro/',
  STOCK: `/${PATH_NAMES.STOCK}/:dealerSlug/(:section)`,
  STOCK_SUBSCRIPTION: `/${PATH_NAMES.SUBSCRIPTION}/${PATH_NAMES.STOCK}/:dealerSlug/(:section)`,
  TERMS: '/condiciones-de-uso',
  TERMS_RESERVATION: '/condiciones-de-uso-reserva',
  TRANSPARENCY: '/transparencia/',
  TECHNICAL_DETAILS: {
    INDEX: `/${PATH_NAMES.TECHNICAL_DETAILS}`,
    COMPARATOR: `/${PATH_NAMES.TECHNICAL_DETAILS}/${PATH_NAMES.COMPARADOR}`,
    COMPARATOR_RESULTS: `/${PATH_NAMES.TECHNICAL_DETAILS}/${PATH_NAMES.COMPARADOR}/:vehicle1Id(/:vehicle2Id)`,
    SEARCH: `/${PATH_NAMES.TECHNICAL_DETAILS}/buscador`,
    MAKE: `/${PATH_NAMES.TECHNICAL_DETAILS}/:make`,
    MODEL: `/${PATH_NAMES.TECHNICAL_DETAILS}/:make/:model`,
    BODY_TYPE: `/${PATH_NAMES.TECHNICAL_DETAILS}/:make/:model/:bodyType/:doors`, // Coches only route
    VERSION_EMPTY: `/${PATH_NAMES.TECHNICAL_DETAILS}/:make/:model/:bodyType/:doors/:version`, // Coches only route
    VERSION: `/${PATH_NAMES.TECHNICAL_DETAILS}/:make/:model/:bodyType/:doors/:version/:versionId`, // Coches only route
    VEHICLE: {
      [APP_NAMES.COCHES]: `/${PATH_NAMES.TECHNICAL_DETAILS}/:make/:model/:bodyType/:doors/:version/:versionId/:vehicleId`, // Coches only route
      [APP_NAMES.MOTOS]: `/${PATH_NAMES.TECHNICAL_DETAILS}/:make/:model/:versionId/:vehicleId` // Motos only route
    },
    VEHICLE_WITHOUT_VERSION: `/${PATH_NAMES.TECHNICAL_DETAILS}/:make/:model/:vehicleId` // Motos only route
  },
  TRANSACTION: {
    BUYER_CHECK_COSTS_LIST: `/transaction/buyer/check-costs-list`,
    BUYER_ID: `/transaction/buyer/id`,
    BUYER_ID_UPLOAD_BACK: `/transaction/buyer/id-upload-back`,
    BUYER_ID_UPLOAD_FRONT: `/transaction/buyer/id-upload-front`,
    BUYER_IDENTITY: `/transaction/buyer/identity`,
    BUYER_INIT_PAYMENT: `/transaction/buyer/init-payment`,
    BUYER_SET_PASSCODE: `/transaction/buyer/passcode`,
    BUYER_PAYMENT_FAIL: `/transaction/buyer/payment-fail`,
    BUYER_PAYMENT_SUCCESS: `/transaction/buyer/payment-success`,
    BUYER_PROFESSION: `/transaction/buyer/profession`,
    SELLER_ACCOUNT: `/transaction/seller/account`,
    SELLER_ID: `/transaction/seller/id`,
    SELLER_ID_UPLOAD_BACK: `/transaction/seller/id-upload-back`,
    SELLER_ID_UPLOAD_FRONT: `/transaction/seller/id-upload-front`,
    SELLER_IDENTITY: `/transaction/seller/identity`,
    TERMS: `/transaction/terms`,
    PRICE: `/transaction/price`,
    PRICE_CONFIRM: `/transaction/price/confirm`
  },
  USER: {
    ALERT: `/${PATH_NAMES.USER}/alert/:userId/:alertId`,
    ALERTS: `/${PATH_NAMES.USER}/alerts`,
    ALERTS_MATCHES: `/${PATH_NAMES.USER}/alerts/:alertId/`,
    DISCOUNTS: `/${PATH_NAMES.USER}/discounts/`,
    FAVORITES: `/${PATH_NAMES.USER}/favorites(/:section)/`,
    MESSAGES: `/${PATH_NAMES.USER}/messages/`,
    PHONE_VERIFICATION: `/${PATH_NAMES.USER}/phone/verification/`,
    PROFILE: `/${PATH_NAMES.USER}/profile/`,
    PROFILE_COMPLETE: {
      PURCHASE: `/${PATH_NAMES.USER}/profile/complete/purchase`
    },
    PROFILE_EDIT: `/${PATH_NAMES.USER}/profile/edit/`,
    TAKEOUT: `/${PATH_NAMES.USER}/takeout`,
    UNSUBSCRIBE: `coches/alerts/unsubscribe/:userId/savedsearch/:alertId`,
    UNSUBSCRIBE_EMAILS: '/cancelar-suscripcion-emails',
    UNSUBSCRIBE_FAVORITE: '/cancelar-suscripcion-favorito/:userId/:adId'
  },
  VEHICLE_APPRAISER: '/tasacion-de-coches/',
  MAKES_DISTRIBUTOR: '/s/',
  WDYL: '/s/:make/:model/',
  VEHICLE_SUGGESTER: {
    INDEX: `/${PATH_NAMES.VEHICLE_SUGGESTER}/`,
    BODY_TYPE: `/${PATH_NAMES.VEHICLE_SUGGESTER}/tipo-de-carroceria/`,
    FUEL_TYPE: `/${PATH_NAMES.VEHICLE_SUGGESTER}/combustible/`,
    SEATS: `/${PATH_NAMES.VEHICLE_SUGGESTER}/plazas/`,
    MAKES: `/${PATH_NAMES.VEHICLE_SUGGESTER}/marcas/`,
    RESULTS: `/${PATH_NAMES.VEHICLE_SUGGESTER}/resultados/`
  },
  VEHICLE_CONFIGURATOR_V3: {
    INDEX: `/${PATH_NAMES.VEHICLE_CONFIGURATOR_V3}(/:make)(/:model/)`,
    FUEL_TYPE: `/${PATH_NAMES.VEHICLE_CONFIGURATOR_V3}/combustible/`,
    TRIM_LEVEL: `/${PATH_NAMES.VEHICLE_CONFIGURATOR_V3}/acabados/`,
    ENGINE: `/${PATH_NAMES.VEHICLE_CONFIGURATOR_V3}/motor/`,
    COLOR: `/${PATH_NAMES.VEHICLE_CONFIGURATOR_V3}/color/`,
    FORM: `/${PATH_NAMES.VEHICLE_CONFIGURATOR_V3}/formulario/`,
    RESULTS: `/${PATH_NAMES.VEHICLE_CONFIGURATOR_V3}/resultado/`
  },
  MODEL_SIZES: '/s/medidas/:make/:model',
  MODEL_DETAIL_INTERIOR_SIZES: '/s/interior/:make/:model',
  MODEL_DETAIL_TRUNK_SIZES: '/s/maletero/:make/:model'
}

// identifies routes on performance dashboards
export const ROUTE_IDS = {
  ADS_LIST: 'adslist',
  ADS_LIST_SEARCH: 'adslist-search',
  ADS_LIST_SUBSCRIPTION: 'adslist-subscription',
  AD_DETAIL_COCHES: 'addetail-coches',
  AD_DETAIL_COCHES_REVAMP: 'addetail-coches-revamp',
  AD_DETAIL_GENERIC: 'addetail-generic',
  AD_DETAIL_MOTOS: 'addetail-motos',
  DEALERS_LIST: 'dealers-list',
  HOME: 'home',
  MODEL_DETAIL: 'model-detail',
  MODEL_SIZES: 'model-sizes',
  NEWS_DETAIL: 'news-detail',
  NEWS_LIST: 'news-list',
  NEWS_LIST_CATEGORY: 'news-list-category',
  NEWS_LIST_TAGS: 'news-list-tags',
  NEWS_LIST_TIPS: 'news-list-tips',
  NEWS_LIST_TRENDS: 'news-list-trends',
  TECHNICAL_DETAILS_COMPARATOR: 'technical-details-comparator',
  TECHNICAL_DETAILS_COMPARATOR_RESULTS: 'technical-details-comparator-results',
  USER_ALERT: 'user-alert',
  USER_ALERTS: 'user-alerts',
  USER_UNSUBSCRIBE: 'user-unsubscribe'
}

export const ADS_DETAIL_COCHES_REGEX = /\/.*-(?<adId>\d{4,9})-[a-z]{2,4}(vo|vn)\.aspx(\?.*)?$/

export const ADS_DETAIL_COCHES_SUBSCRIPTION_REGEX = /\/renting\/.*-(?<adId>\d{4,9})-vsre(\?.*)?$/

export const ADS_DETAIL_MOTOS_REGEX = /\/(ocasion|nuevas)\/.*-(?<adId>\d{5,8})\.htm(\?.*)?$/

export const ADS_DETAIL_PREVIEW_REGEX = /preview\/(?<adId>[a-zA-Z0-9]{1,})/g

export const DEALERS_LIST_REGEX = /^\/concesionarios\//

export const MODEL_DETAIL_REGEX = /^\/s\/[a-zA-Z0-9_-]+\/[a-zA-Z0-9_-]+\/$/

export const TECHNICAL_DETAILS_REGEX = {
  ALL: /^\/fichas_tecnicas\//,
  VEHICLES: /^\/fichas_tecnicas\/(?!comparador\/|buscador\/)/,
  COMPARATOR: /^\/fichas_tecnicas\/comparador/,
  SEARCH: /^\/fichas_tecnicas\/buscador/
}

export const NEWS_CATEGORY_PATHS = {
  [APP_NAMES.COCHES]: ['novedades', 'videos', 'pruebas', 'comparativas'],
  [APP_NAMES.MOTOS]: ['novedades', 'videos', 'pruebas', 'actualidad', 'reportajes']
}

export const NEWS_DETAIL_REGEX = {
  [APP_NAMES.COCHES]:
    /(\/noticias\/(?<slug1>((?!((novedades|videos|pruebas|comparativas|t)\/|[\\?&]([^&=]+)=([^&=]+))).+))|(\/(videos|tendencias|comparativas|consejos)\/(?<slug2>.+)))/,
  [APP_NAMES.MOTOS]:
    /(\/noticias\/(?<slug1>((?!((novedades|videos|pruebas|actualidad|reportajes|t)\/|[\\?&]([^&=]+)=([^&=]+))).+))|(\/(videos|tendencias|comparativas|consejos)\/(?<slug2>.+)))/
}

export const STOCK_REGEX = /^\/concesionario\/[^/]{1,}\/$/
export const STOCK_SUBSCRIPTION_REGEX = /^\/renting\/concesionario\/[^/]{1,}\/$/

export const USER_FAVOURITES_REGEX = /^\/user\/favorites\/?$/

export const NEWS_COMMENTS_PATH_PATTERN = `/opiniones/:category/:slug(/:optional1)(/:optional2)(/:optional3)(/:optional4)`

/*
 * IMPORTANT !
 * A route should not be added to EXACT_REACT_ROUTES
 * if it hasn't been migrated for both sites.
 */
export const EXACT_REACT_ROUTES = [
  `${ROUTES.CHECKOUT.INDEX}/`,
  `${ROUTES.CHECKOUT.INDEX}/${ROUTES.CHECKOUT.SUCCESS}/`,
  `${ROUTES.CHECKOUT.INDEX}/${ROUTES.CHECKOUT.ERROR}/`,
  `${ROUTES.CHECKOUT.INDEX}/${ROUTES.CHECKOUT.PENDING}/`,
  `${ROUTES.CHECKOUT.INDEX}/${ROUTES.CHECKOUT.REFUND_ERROR}/`,
  `${ROUTES.CHECKOUT.INDEX}/${ROUTES.CHECKOUT.ACTIVATION_ERROR}/`,
  `${ROUTES.CHECKOUT.INDEX}/${ROUTES.CHECKOUT.REQUEST_ERROR}/`,
  `${ROUTES.COOKIE_POLICY}/`,
  `${ROUTES.HOME}`,
  `${ROUTES.INSTANT_OFFER_STANDALONE.COCHES}/`,
  `${ROUTES.INSTANT_OFFER_STANDALONE.MOTOS}/`,
  `${ROUTES.LOGIN}/`,
  `${ROUTES.PAYMENT_AD}/`,
  `${ROUTES.PRODUCTS}/`,
  ROUTES.AD_MANAGEMENT.MY_ADS,
  ROUTES.AD_PUBLISHER.PUBLISH_MY_AD,
  ROUTES.AD_PUBLISHER.PUBLISH_MY_AD_CATEGORY,
  `${ROUTES.EDIT_MY_AD}/`,
  `${ROUTES.RATING}`,
  ROUTES.RECOMMENDATIONS,
  `${ROUTES.TRANSPARENCY}`,
  `${ROUTES.USER.TAKEOUT}/`,
  `${ROUTES.USER.FAVORITES}/`,
  `${ROUTES.USER.PROFILE}`,
  `${ROUTES.DEALERS_LIST.INDEX}/`,
  `${ROUTES.DEALERS_LIST.PROVINCE}/`,
  `${ROUTES.INSURANCE}`,
  `${ROUTES.NET}/`,
  `${ROUTES.LANDING_INSTANT_OFFER}/`,
  `${ROUTES.LANDING_INSTANT_OFFER_TEST}/`,
  ROUTES.VEHICLE_APPRAISER,
  `${ROUTES.SELLER_SECURE_PAYMENT_BENEFITS}`
]

/*
 * IMPORTANT !
 * A route should not be added to PARTIAL_REACT_ROUTES
 * if it hasn't been migrated for both sites.
 */
export const PARTIAL_REACT_ROUTES = [
  `${ROUTES.NEWS.INDEX}/`,
  `${ROUTES.NEWS.INDEX}/?pg`,
  `${ROUTES.NEWS.INDEX}/?q`,
  `${ROUTES.NEWS.INDEX}/t/`,
  `${ROUTES.NEWS_SECTION_TIPS}/`,
  `${ROUTES.NEWS_SECTION_TIPS}/?pg`,
  `${ROUTES.NEWS_SECTION_TRENDS}/`,
  `${ROUTES.NEWS_SECTION_TRENDS}/?pg`,
  `${ROUTES.NEWS_SECTION_COMPARATIVAS}/`,
  `${ROUTES.NEWS_SECTION_VIDEOS}/`,
  `${ROUTES.NEWS_PREVIEW.INDEX}/`,
  ROUTES.AD_PUBLISHER.PUBLISH_YOUR_VEHICLE_WITH_PLATE,
  ROUTES.AD_PUBLISHER.PUBLISH_MY_AD_WITH_PLATE,
  ROUTES.SELL_MY_VEHICLE.COCHES.INDEX,
  ROUTES.SELL_MY_VEHICLE.MOTOS.INDEX,
  ROUTES.INSTANT_OFFER.COCHES,
  ROUTES.INSTANT_OFFER.MOTOS,
  ROUTES.ADS_LIST_SUBSCRIPTION,
  ROUTES.DEALERS_LIST.PROVINCE,
  ROUTES.DETAIL.INDEX,
  ROUTES.DETAIL_PREVIEW,
  ROUTES.MESSAGING_ACTION_PROXY.C2B_SELLER,
  ROUTES.MESSAGING_ACTION_PROXY.C2B_BUYER,
  ROUTES.MESSAGING_ACTION_PROXY.RESERVATION_SELLER,
  ROUTES.MESSAGING_ACTION_PROXY.RESERVATION_BUYER,
  ROUTES.MESSAGING_ACTION_PROXY.TRANSACTION_SELLER,
  ROUTES.MESSAGING_ACTION_PROXY.TRANSACTION_BUYER,
  // Dealers (concesionario + renting/concesionario) — one bundle per tenant.
  `/${PATH_NAMES.STOCK}/`,
  `/${PATH_NAMES.SUBSCRIPTION}/${PATH_NAMES.STOCK}/`,
  // Make (/s/:make) + ModelDetail (/s/:make/:model). SSR needs the prefix to
  // pick the RR7 bundle instead of falling back to the legacy server.
  ROUTES.MAKES_DISTRIBUTOR,
  // Opiniones — alternate URL that serves the same News/Detail page.
  '/opiniones/',
  // Alerts unsubscribe (coches-specific).
  '/coches/alerts/unsubscribe/'
]

export const PUBLIC_KEY_STRIPE = process.env.PUBLIC_KEY_STRIPE
export const PUBLIC_KEY_GETSTREAM = process.env.PUBLIC_KEY_GETSTREAM

// Pages whose Core Web Vitals `@s-ui/react-web-vitals` reports: legacy route paths and ids, matched
// against the legacy route of the URL (see `helpers/legacyRoutes.js`).
export const WEB_VITALS_PATHNAMES = [
  ROUTES.ADS_LIST_SUBSCRIPTION,
  ROUTES.DEFAULT,
  ROUTES.DETAIL.AD,
  ROUTES.HOME,
  ROUTES.MAKES_DISTRIBUTOR,
  ROUTES.MODEL_SIZES,
  ROUTES.TECHNICAL_DETAILS.COMPARATOR,
  ROUTES.TECHNICAL_DETAILS.COMPARATOR_RESULTS,
  ROUTES.USER.ALERT,
  ROUTES.USER.ALERTS,
  ROUTES.USER.UNSUBSCRIBE,
  ROUTES.WDYL,
  ROUTE_IDS.AD_DETAIL_COCHES,
  ROUTE_IDS.AD_DETAIL_COCHES_REVAMP,
  ROUTE_IDS.AD_DETAIL_MOTOS,
  ROUTE_IDS.DEALERS_LIST,
  ROUTE_IDS.MODEL_DETAIL,
  ROUTE_IDS.NEWS_DETAIL,
  ROUTE_IDS.NEWS_LIST,
  ROUTE_IDS.NEWS_LIST_CATEGORY,
  ROUTE_IDS.NEWS_LIST_TAGS,
  ROUTE_IDS.NEWS_LIST_TIPS,
  ROUTE_IDS.NEWS_LIST_TRENDS
]
